if (!window.cc_View) {
	window.cc_View = {};
}

(function () {
	"use strict";
	
	cc_View.blankSelectedOption = '<option value="" selected></option>';
	cc_View.dayOptions = cc_View.blankSelectedOption;
	cc_View.monthOptions = cc_View.blankSelectedOption;

	for(var i = 1; i <= 12; i++) {
		cc_View.monthOptions += '<option value="' + i + '">' + i +'</option>';
	};

	for(var i = 1; i <= 31; i++) {
		cc_View.dayOptions += '<option value="' + i + '">' + i +'</option>';
	};
	
	cc_View.currentDate = new Date();
	cc_View.currentYear = cc_View.currentDate.getFullYear();
	cc_View.currentMonthOfYear = cc_View.currentDate.getMonth() + 1;
	cc_View.currentDayOfMonth = cc_View.currentDate.getDate();

	cc_View.getPageNavigatorItemId = function (pageId) {
		return 'navigator_item_' + cc_Util.toWebSafeId(pageId);
	};
	
	cc_View.getPageDivId = function (pageId) {
		return 'page_' + cc_Util.toWebSafeId(pageId);
	};
	
	cc_View.getQuestionPanelDivId = function (questionId) {
		return 'question_' + cc_Util.toWebSafeId(questionId);
	};
	
	cc_View.findResultPanelById = function (id) {
		return $('.questionResultContainer [cc-result-panel=' + id + ']');
	};
	
	cc_View.findErrorPanelById = function (id) {
		return $('.questionErrorContainer [cc-error-panel=' + id + ']');
	};
	
	cc_View.createResultMessage = function (result) {
		return '<div class="result_text">' + result + '</div>';
	};
	
	cc_View.createErrorMessage = function (message, raisedBy) {
		// raised by should be either 'server' or 'client'
		return '<div class="errorText" data-raised-by="' + (raisedBy ? raisedBy : 'server') + '">' + message + '</div>';
	};

	cc_View.createQuickfillDefaultScreen = function () {
		return 	'<div id="cloudcase-form-container">' +
					'<div id="cloudcase-page-container">' +
						'<div id="page">' +
							'<div id="page-content" class="panel-group"></div>' +
						'</div>' +
					'</div>' +
				'</div>';
	};
	
	cc_View.createPage = function (page) {
		return 	'<div id="' + cc_View.getPageDivId(page.id) + '" cc-page-id="' + page.id + '" cc-page-index="' + page.pageIndex + '" class="panel panel-default">' +
					'<div class="panel-heading peer">' +
						'<h4 class="panel-title">' +
							'<a data-toggle="collapse" data-parent="#accordion" href="#' + page.id + '">' + page.text + '</a>' +
						'</h4>' +
					'</div>' +
					'<div id="' + page.id + '" class="panel-collapse collapse questions">' +
						'<div class="panel-body">' +
							'<div class="sections-container">' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>';
	};

	cc_View.createPageNavigatorItem = function (page) {
		var navigatorItemId = cc_View.getPageNavigatorItemId(page.id);

		return '<li id="' + navigatorItemId + '" class="page_navigator_item" cc-page-id="' + cc_Util.toWebSafeId(page.id) + '">' +
					cc_View.createPageNavigatorPlaceholderIcon() +
				 	'<a id="' + navigatorItemId + '_link">' + page.text + '</a>' + 
				'</li>';
	};

	cc_View.createPageGroupNavigatorItem = function (pageGroupId, pageNavigator) {
		var icon;
		var className;
		if (cc_UI.pageGroupHasErrors(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorErrorIcon(pageGroupId);
		} else if (cc_UI.pageGroupHasWarnings(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorWarningIcon(pageGroupId);
		} else if (cc_UI.pageGroupIsCompleted(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorCompletedIcon(pageGroupId);
			className = "completed";
		} else {
			icon = cc_View.createPageNavigatorPlaceholderIcon();
		}

		var navigatorItemId = cc_View.getPageNavigatorItemId(pageGroupId);
		return '' +
			'<li id="' + navigatorItemId + '" class="page_group_navigator_item subpageParent '+ className + '"  cc-page-group-id="' + cc_Util.toWebSafeId(pageGroupId) + '">' +
					icon +
					'<a>' + pageGroupId + '</a>' +
				'<div class="chevron"></div>' +
			'</li>'
	}

	cc_View.createPageNavigatorCompletedIcon = function (pageId) {
		return	'<i class="completedIcon icon-rab-check-green-glow" cc-page-completed="' + pageId + '" title="This page is complete">' +
					cc_Icon.completedIcon() +
					// cc_Icon.connector() +
				'</i>';
	};

	cc_View.createAccentedCompletedIcon = function (pageId) {
		return	'<i class="completedIcon" cc-page-completed="' + pageId + '" title="This page is complete">' +
			cc_Icon.accentedCompletedIcon() +
			// cc_Icon.connector() +
			'</i>';
	};

	cc_View.createPageNavigatorErrorIcon = function (pageId) {
		return	'<i class="errorIcon icon-rab-i-danger" cc-page-error="' + pageId + '"title="This page contains errors">' +
					cc_Icon.errorIcon() +
					// cc_Icon.connector() +
				'</i>';
	};

	cc_View.createPageNavigatorWarningIcon = function (pageId) {
		return	'<i class="warningIcon" cc-page-warning="' + pageId + '"title="This page contains new questions">' +
					cc_Icon.warningIcon() +
					// cc_Icon.connector() +
				'</i>';
	};

	cc_View.createPageNavigatorPlaceholderIcon = function() {
		return	'<i class="placeholderIcon icon-rab-">' +
					cc_Icon.placeholderIcon() +
					// cc_Icon.connector() +
				'</i>';

	}

	cc_View.createPageNavigatorActiveEditIcon = function() {
		return '<i class="activeEditIcon">' +
					cc_Icon.activeEditIcon() +
					// cc_Icon.connector() +
				'</i>';
	}
	
	cc_View.createButtonPanel = function(isInterviewComplete, next, previous, save){
		// don't include buttons where there is no button text, as button has been excluded
		return 	"<div class='buttonPanel'>" +
						(previous ? "<button class='btn btn-default previous'>" + previous + "</button>" : '') +
						(next ? "<button class='btn btn-primary long next'>" + next + "</button>" : '') +
				"</div>";
	};
	
	cc_View.getSectionDivId = function (pageId, section) {
		return 'id_section_' + cc_Util.toWebSafeId(pageId) + '_' + cc_Util.toWebSafeId(section);
	};
	
	cc_View.createSection = function (pageId, section) {
		var html = '<div id="' + cc_View.getSectionFieldsetId(pageId, section) + '" class="sectionHeader">';
		
		if(section){
			html +=		'<legend>' + section + '</legend>';
		}
		
		html +=			'<div id="' + cc_View.getSectionDivId(pageId, section) + '"></div>' +
					'</div>';
		
		return html;
	};
	
	cc_View.getSectionFieldsetId = function (pageId, section) {
		return 'fieldset_section_' + cc_Util.toWebSafeId(pageId) + '_' + cc_Util.toWebSafeId(section);
	};

	cc_View.isViewableQuestion = function (question) {
		var hasValue = function(value){
			return (value != null && value.length > 0);
		};

		return question && (hasValue(question.text) || hasValue(question.values) || hasValue(question.entered) ||
			hasValue(question.error) || question.type.hasAnEnterableType || cc_Model.getProperty(cc_Renderer.PROPERTY_PLACEHOLDER, question) != null);
	};
	
	cc_View.createQuestionHtml = function (question) {	
		var classes = 'questionPanel';
		
		classes += ' ' + cc_View.createQuestionPanelComponentVisibilityClasses(question).join(' ');
		
		if(question.concealed == true){
			classes += ' concealed';
		}
		
		if(cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT, question) == 'Horizontal'){
			classes += ' layoutHorizontal';
		}
		
		var html = '<div id="' + cc_View.getQuestionPanelDivId(question.id) + '" cc-panel="' + question.id + '" class="' + classes + '">';
		
		if (question.type.hasAnInputType) {
			switch (question.type.value) {
			case 'multi-select':
				html += cc_View.createMultiSelectQuestionHtml(question);
				break;
			case 'single-select':
			case 'boolean':
				html += cc_View.createSingleSelectQuestionHtml(question);
				break;
			case 'free-text':
				html += cc_View.createFreeTextQuestionHtml(question);
				break;
			case 'number':
			case 'range':
				html += cc_View.createNumberQuestionHtml(question);
				break;
			case 'date':
				html += cc_View.createDateQuestionHtml(question);
				break;
			case 'search':
				html += cc_View.createSearchQuestionHtml(question);
				break;
			case 'add-document':
				html += cc_View.createAddDocumentQuestionHtml(question);
				break;
			case 'external-widget':
				html += cc_View.createExternalWidgetQuestionHtml(question);
				break;
			}
			
		}else{
			html +=	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						cc_View.createQuestionHelpPanelHtml(question) +
						cc_View.createQuestionResultAndErrorPanelHtml(question) +
					'</div>';
		}
	
		if (question.hasSubQuestions) {
			html += cc_View.createSubQuestionsHtml(question);
		}
		
		html += '</div>';
		
		return html;
	};
	
	cc_View.createQuestionPanelComponentVisibilityClasses = function (question) {
		
		// NOTE: cc_Renderer.registerQuestionPanelUpdate() requires that all classes start with either 'shown' or 'hidden' or 'disabled'
		
		var hasValue = function(value){
			return (value != null && value.length > 0);
		};
		
		var classes = [];
		var isQuestionTriggerType = cc_Model.task ? cc_Model.task.triggerType === 'QUESTION_TRIGGER' : false;
		
		var shownQuestionPanel = cc_View.isViewableQuestion(question) == true
		classes.push(shownQuestionPanel ? 'shownQuestionPanel' : 'hiddenQuestionPanel');
		
		var shownQuestionTextPanel = hasValue(question.text)
		classes.push(shownQuestionTextPanel ? 'shownQuestionTextPanel' : 'hiddenQuestionTextPanel');

		var disabledQuestionContentPanel = question.disabled;
		if (disabledQuestionContentPanel === true) {
			classes.push('disabledQuestionContentPanel');
		}
		
		var shownQuestionOutcomePanel = (isQuestionTriggerType === false && hasValue(question.error)) || hasValue(question.result);
		classes.push(shownQuestionOutcomePanel ? 'shownQuestionOutcomePanel' : 'hiddenQuestionOutcomePanel');
		
		var hasTextAndEnterable = hasValue(question.text) && question.type.hasAnEnterableType
		classes.push(hasTextAndEnterable ? 'shownTextAndEnterable' : 'hiddenTextOrEnterable');
		
		var hiddenTextAndEnterable = hasValue(question.text) === false && question.type.hasAnEnterableType === false;
		if(hiddenTextAndEnterable === true){
			classes.push('hiddenTextAndEnterable');
		}
		
		return classes;
	};

	cc_View.createQuestionHeadingHtml = function (question) {
		var text = cc_View.createQuestionText(question);

		// when question does not include a text value still attach the questionText elements
		// as the value can be modified via a CC.getQuestion().setText() call.
		// without the questionText added the text value modifications will never be displayed
		var html = 	'<div class="questionAnnotationsAndText">';

		if(text){
			html +=		'<div class="questionAnnotations">' +
				cc_View.createQuestionHeadingMustAnswerHtml(question.mustAnswer) +
				'</div>';
		}

		if(text && cc_Model.getProperty("Heading", question)){
			html +=		'<div class="questionText" cc-text="' + question.id + '">' +
				'<legend>' + text + '</legend>' +
				'</div>';

		}else if(text && cc_Model.getProperty("IntroText", question) && cc_Model.getProperty("IntroTextImage", question)){
			html +=		'<div class="intro-text-with-image questionText" cc-text="' + question.id + '">' +
				'<span>' +
				'<div>' +
				text +
				'</div>' +
				'<div>' +
				'<img src="/' + cip_Common.getContextPath() + '/images/' + cip_Common.brandId  + '/' + cc_Model.getProperty("IntroTextImage", question) + '">' +
				'</div>' +
				'</span>' +
				'</div>';

		}else if(text && cc_Model.getProperty("IntroText", question)){
			html +=		'<div class="intro-text questionText" cc-text="' + question.id + '">' +
				'<span>' +
				'<div>' +
				text +
				'</div>' +
				'</span>' +
				'</div>';

		}else if(text && cc_Model.getProperty("AlertSuccessText", question)){
			html +=		'<div class="questionText" cc-text="' + question.id + '">' +
				'<span>' +
				'<div class="alert-success">' +
				text +
				'</div>' +
				'</span>' +
				'</div>';

		}else{
			text = cip_Custom.doesQuestionRequireFeatureText(question) ? ('<p class="text-feature">' + text + '</p>') : text;

			html +=		'<div class="questionText flex" cc-text="' + question.id + '">' +
				'<span>' + (text ? text : '') + '</span>' +
				cc_View.createQuestionHelpButtonHtml(question) +
				'</div>';
		}

		html +=		'</div>';

		return html;
	};
	
	cc_View.createQuestionHeadingMustAnswerHtml = function (isMustAnswer) {
		// Intentionally blocking the "required" annotation because it is not currently needed
		// but the styling of it is prepared for when we want it
		if (!cc_Config.showQuestionOptionalAnnotation && isMustAnswer) {
			return '<div class="text-error">*</div>'
		// if (false && isMustAnswer) {
		// 	return	"<div class='question-mandatory-pill__container'>" +
		// 				"<span class='question-pill__inner'>Required</span>" +
		// 			"</div>";
		} else {
			return '';
		}
	};

	cc_View.createQuestionHeadingOptionalHtml = function (question) {
		if (cc_Config.showQuestionOptionalAnnotation && !question.mustAnswer) {
			if (question.type.value === 'type-less') {
				return '';
			} else {
				return	"<div class='question-optional-pill__container'>" +
							"<span class='question-pill__inner'>Optional</span>" +
						"</div>";
			}
		} else {
			return '';
		}
	}
	
	cc_View.createMultiSelectQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html = 
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, question.text ? 'fixedWidthQuestion' : 'floatingWidthQuestion') + '" cc-type="' + question.type.value + '">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">' +
						'<div class="multiAnswerGroup" cc-group-question-id="' + question.id + '">';

		html += 			cc_View.createMultiSelectOptionsHtml(question);
	
		html +=			'</div>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
			
		return html;
	};

	cc_View.createMultiSelectOptionsHtml = function (question) {
		var html = '<div class="btn-group" data-toggle="buttons">';
		var isLargeOption = cc_Model.getProperty("LargeOptions", question);

		$.each(question.values, function (i) {
			var optionId = question.id + '_' + cc_Util.escapeHtmlAttributeValue(this.value);

			html +=     '<label class="' + (isLargeOption ? 'large-option ' : '') + 'btn btn-lg btn-default" for="' + optionId + '" cc-disableable="' + question.id + '">' +
				'<div>';

			var optionImage = cc_Model.getProperty("Option" + (i + 1) + "Image", question);
			if(optionImage){
				html +=     '<img src="/' + cip_Common.getContextPath() + '/images/' + cip_Common.brandId  + '/' + optionImage + '">';
			}

			html +=     '</div>' +
				'<div>' +
				'<input id="' + optionId + '" type="checkbox" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
				this.value +
				'</div>' +
				'<div style="margin:auto;display: block;">' +
				'<i class="unchecked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="11.5" fill="white" stroke="#015060"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0777 11.1434C18.6123 11.1434 19.0456 11.5015 19.0456 11.9434C19.0456 12.3852 18.6123 12.7434 18.0777 12.7434H7.28429C6.74974 12.7434 6.31641 12.3852 6.31641 11.9434C6.31641 11.5015 6.74974 11.1434 7.28429 11.1434H18.0777Z" fill="#CBD6E1"></path></svg></i>' +
				'<i class="checked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="12" fill="#015060"></circle><path d="M8.83805 12.0165C8.50528 11.7129 7.98262 11.7293 7.67065 12.0532C7.35867 12.377 7.37554 12.8857 7.7083 13.1894L11.0119 16.2037C11.3666 16.5273 11.9303 16.4842 12.2287 16.1108L18.0101 8.87637C18.2901 8.52595 18.2253 8.02092 17.8652 7.74837C17.5052 7.47582 16.9863 7.53895 16.7062 7.88937L11.4809 14.428L8.83805 12.0165Z" fill="#FEFEFF"></path></svg></i>' +
				'</div>' +
				'</label>';
		});
		html += '</div>';
		return html;
	};
	
	cc_View.createSingleSelectQuestionHtml = function (question) {
		if(question.type.value == 'boolean' || question.type.styleName == 'radio'){
			return cc_View.createSingleSelectRadioQuestionHtml(question);
			
		}else{
			return cc_View.createSingleSelectListQuestionHtml(question);
		}
	};
	
	cc_View.createSingleSelectListQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html =
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="list">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">';

		if(question.type.styleName == 'auto-complete'){
			html +=		'<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="auto-complete" ' + cc_View.createQuestionPlaceholder(question) + '/>';
			
		}else{
			html +=		'<select class="form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="list">';

			html += 		cc_View.createSingleSelectListOptionsHtml(question);
					
			html +=		'</select>';
		}
		
		html +=		'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
			
		return html;
	};
	
	cc_View.createSingleSelectListOptionsHtml = function (question) {
		var html = '<option value="" selected></option>';
		
		$.each(question.values, function () {
			html += '<option value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '">' + this.value +'</option>';
			return true;
		});
		
		return html;
	};
	
	cc_View.createSingleSelectRadioQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html = 
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, question.text ? 'fixedWidthQuestion' : 'floatingWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="radio">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">' +
						'<div class="multiAnswerGroup" cc-group-question-id="' + question.id + '">';

		html += 			cc_View.createSingleSelectRadioOptionsHtml(question);
							
		html +=			'</div>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
		return html;
	};

	cc_View.createSingleSelectRadioOptionsHtml = function (question) {

		var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);
		var className = styleProperty === "ButtonGroup" ? "grouped-button" : "";
		var isLargeOption = cc_Model.getProperty("LargeOptions", question);
		var html = '';

		if (styleProperty === "ButtonGroup") {
			html += '<div class="btn-group" data-toggle="buttons">';
		} else if (styleProperty !== "Confirm") {
			html += '<div class="radio-group">';
		}

		$.each(question.values, function (i) {
			var optionId = question.id + '_' + cc_Util.escapeHtmlAttributeValue(this.value);
			var path = '/' + cip_Common.getContextPath() + '/images/' + cip_Common.brandId  + '/';
			var infoPicUrl = cc_Model.getProperty("InfoPicUrl" + (i + 1), question);

			if (styleProperty == "ButtonGroup") {


				if (infoPicUrl) {
					html += '' +
						'<label class="btn btn-lg btn-default ' + (isLargeOption ? 'large-option ' : 'regular-option ') + (infoPicUrl ? 'includes-option-image ' : '') + className + '" for="' + optionId + '" cc-disableable="' + question.id + '">' +
							'<span class="info-pic ' + infoPicUrl + '"></span>' +
							'<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
							'<span>' + this.value + '</span>' +
							'<div class="custom-radio-pic-btn">' +
							'<i class="unchecked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="11.5" fill="white" stroke="#015060"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0777 11.1434C18.6123 11.1434 19.0456 11.5015 19.0456 11.9434C19.0456 12.3852 18.6123 12.7434 18.0777 12.7434H7.28429C6.74974 12.7434 6.31641 12.3852 6.31641 11.9434C6.31641 11.5015 6.74974 11.1434 7.28429 11.1434H18.0777Z" fill="#CBD6E1"></path></svg></i>' +
							'<i class="checked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="12" fill="#015060"></circle><path d="M8.83805 12.0165C8.50528 11.7129 7.98262 11.7293 7.67065 12.0532C7.35867 12.377 7.37554 12.8857 7.7083 13.1894L11.0119 16.2037C11.3666 16.5273 11.9303 16.4842 12.2287 16.1108L18.0101 8.87637C18.2901 8.52595 18.2253 8.02092 17.8652 7.74837C17.5052 7.47582 16.9863 7.53895 16.7062 7.88937L11.4809 14.428L8.83805 12.0165Z" fill="#FEFEFF"></path></svg></i>' +
							'</div>' +
						'</label>';
				} else {
					html += '' +
						'<label class="btn btn-lg btn-default ' + (isLargeOption ? 'large-option ' : 'regular-option ') + (infoPicUrl ? 'includes-option-image ' : '') + className + '" for="' + optionId + '" cc-disableable="' + question.id + '">' +
							'<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
							'<div style="margin:auto;display: block;">' +
							'<i class="unchecked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="11.5" fill="white" stroke="#015060"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0777 11.1434C18.6123 11.1434 19.0456 11.5015 19.0456 11.9434C19.0456 12.3852 18.6123 12.7434 18.0777 12.7434H7.28429C6.74974 12.7434 6.31641 12.3852 6.31641 11.9434C6.31641 11.5015 6.74974 11.1434 7.28429 11.1434H18.0777Z" fill="#CBD6E1"></path></svg></i>' +
							'<i class="checked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="12" fill="#015060"></circle><path d="M8.83805 12.0165C8.50528 11.7129 7.98262 11.7293 7.67065 12.0532C7.35867 12.377 7.37554 12.8857 7.7083 13.1894L11.0119 16.2037C11.3666 16.5273 11.9303 16.4842 12.2287 16.1108L18.0101 8.87637C18.2901 8.52595 18.2253 8.02092 17.8652 7.74837C17.5052 7.47582 16.9863 7.53895 16.7062 7.88937L11.4809 14.428L8.83805 12.0165Z" fill="#FEFEFF"></path></svg></i>' +
							'</div>' +
							'<span>' + this.value + '</span>' +
						'</label>';
				}
			} else if (styleProperty == "Confirm") {
				html += '<div class="radio-inline">' +
					'<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
					'<label class="answerText unselectable" for="' + optionId + '" >' + this.value + '</label>' +
					'</div>';
			} else {
				html += '<div class="radio-container"><label class="radio-label ' + (isLargeOption ? 'large-option ' : 'regular-option ') + (infoPicUrl ? 'includes-option-image ' : '') + className + '" for="' + optionId + '" cc-disableable="' + question.id + '">';

				if (infoPicUrl) {
					html += '<span class="info-pic ' + infoPicUrl + '">' +
						/*'<img src="' + path + infoPicUrl + '" class="info-pic">' +*/
						'</span>';
				}

				html += '<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
					'<i class="unchecked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="11.5" fill="white" stroke="#015060"></circle><path fill-rule="evenodd" clip-rule="evenodd" d="M18.0777 11.1434C18.6123 11.1434 19.0456 11.5015 19.0456 11.9434C19.0456 12.3852 18.6123 12.7434 18.0777 12.7434H7.28429C6.74974 12.7434 6.31641 12.3852 6.31641 11.9434C6.31641 11.5015 6.74974 11.1434 7.28429 11.1434H18.0777Z" fill="#CBD6E1"></path></svg></i>' +
					'<i class="checked"><svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12.5" cy="12" r="12" fill="#015060"></circle><path d="M8.83805 12.0165C8.50528 11.7129 7.98262 11.7293 7.67065 12.0532C7.35867 12.377 7.37554 12.8857 7.7083 13.1894L11.0119 16.2037C11.3666 16.5273 11.9303 16.4842 12.2287 16.1108L18.0101 8.87637C18.2901 8.52595 18.2253 8.02092 17.8652 7.74837C17.5052 7.47582 16.9863 7.53895 16.7062 7.88937L11.4809 14.428L8.83805 12.0165Z" fill="#FEFEFF"></path></svg></i>' +
					'<span>' + this.value + '</span>' +
					'</label></div>';
			}
		});

		if (styleProperty == "ButtonGroup" || styleProperty !== "Confirm") {
			html += '</div>';
		}

		return html;
	};

	cc_View.createSearchQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html =
			'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
				cc_View.createQuestionHeadingHtml(question) +
				'<div class="questionContent searchQuestion ' + disabledOutputClass +'">' +
					'<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="auto-complete" ' + cc_View.createQuestionPlaceholder(question) + '/>' +
					'<div class="searchAction searchEditContent" cc-hideable-panel="' + question.id + '">' +
						'<input cc-search-edit-button="' + question.id + '" class="editSearchButton btn btn-primary small" type="button" value="Edit" />' +
					'</div>' +
				'</div>' +
				'<div class="searchAction searchAgainContent" cc-hideable-panel="' + question.id + '">' +
					'<a class="searchAgainLink"><span class="cursor-pointer underline text-teal">Click here</span><span> to search again</span></a>' +
				'</div>';
		if(question.type.searchMatch.required === false && question.type.searchMatch.noMatchText){
			html +=	'' +
				'<div cc-hideable-panel="' + question.id + '" class="searchAction searchNoMatchContent">' +
					'<a class="searchNoMatchLink cursor-pointer">' + question.type.searchMatch.noMatchText + '</a>' +
				'</div>';
		}
		html += cc_View.createQuestionHelpPanelHtml(question) +
				cc_View.createQuestionResultAndErrorPanelHtml(question) +
			'</div>';
			
		return html;
	};

	cc_View.createNumberQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		return 	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass + '">' +
						'<input class="form-control" type="' + (cc_UI.isMobileDevice() === true ? 'number' : 'text') + '" cc-field="' +
							question.id + '" cc-disableable="' + question.id + '" style="display:none" />' +
						'<input class="form-control" type="text" cc-decorator-field="' +
							question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
	};
	
	cc_View.createFreeTextQuestionHtml = function (question) {
		var isFullWidthQuestion = question.type.styleName == 'text-area';
		var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";
		
		var html = '<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, isFullWidthQuestion == true ? 'fullWidthQuestion' : 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="' + question.type.styleName + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						'<div class="questionContent ' + disabledOutputClass + '">';
		
		if(question.type.styleName == 'text-area'){
			var heightProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_HEIGHT, question);
			
			html +=		'<textarea class="text form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) +
							(heightProperty ? ' style="height:' + heightProperty + ';"' : '') + 
						'></textarea>';
		}else if(styleProperty == 'Password'){
			html += 	'<input class="form-control" type="password" name="password-' + cc_Util.toWebSafeId(question.id) + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>';
		}else{
			html += 	'<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>';
		}
		
		html += 	'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
		
		return html;
	};
	
	cc_View.createSubQuestionsHtml = function (question) {
		var html = '';
		
		if(question.subQuestions && question.subQuestions.length > 0){
			cc_Util.invokeOnElements(question.subQuestions, function () {
				html += cc_View.createQuestionHtml(this);
			});
		}
		
		return html;
	};
	
	cc_View.createExternalWidgetQuestionHtml = function (question) {
		var html = 	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">';

		html +=	'' +
			cc_View.createQuestionHelpPanelHtml(question) +
			cc_View.createQuestionResultAndErrorPanelHtml(question);

		var renderedQuestionHtml = eval(question.type.externalWidget.renderFunktion + ';' + question.type.externalWidget.renderFunktionName + '();');
		if(renderedQuestionHtml){
			html += renderedQuestionHtml;
		}

		html +=		'</div>';
		
		return html;
	};
	
	cc_View.createAddDocumentQuestionHtml = function (question) {
		return 	'<form>' +
					'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						'<div class="questionContent"></div>' +
						cc_View.createQuestionHelpPanelHtml(question) +
						cc_View.createQuestionResultAndErrorPanelHtml(question) +
					'</div>'+
				'</form>';
	};

	cc_View.createAddDocumentQuestionContentHtml = function (question) {
		var html;

		if(cc_Config.isExecutingWithinWorkflow === true){

			// entered can be null for multiple answer questions
			if(question.entered && question.entered.length == 2){
				html = '<div class="addedDocumentPanel">' +
							'<div class="flex gap-2.5 items-center">' +
								'<i>' +
									'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
										'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
									'</svg>' +
								'</i>' +
								'<span>' + question.entered[1] + '</span>' +
							'</div>' +
							'<div>' +
								'<input cc-disableable="' + question.id + '" cc-field="' + question.id + '" value="' + question.entered[0] + cc_Config.fieldDelimiter + question.entered[1] + '" type="hidden" />' +
								'<input cc-disableable="' + question.id + '" class="removeDocumentButton"' + ' data-documentid="' + question.entered[0] + '" class="btn btn-primary" type="button" value="Remove" />' +
							'</div>';
					'</div>';
			}else{
				html = 	'<label class="filePanel">' +
							'<div class="missingDocumentPanel">' +
								'<div class="flex gap-2.5 items-center">' +
									'<i>' +
										'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
											'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
										'</svg>' +
									'</i>' +
									'<span>No file uploaded</span>' +
								'</div>' +
								'<div>' +
									'<input cc-disableable="' + question.id + '" name="environment" type="hidden" value="' + cc_Config.environment + '" />' +
									'<input cc-disableable="' + question.id + '" name="workflowName" type="hidden" value="' + cc_Config.workflowName + '" />' +
									'<input cc-disableable="' + question.id + '" name="workflowVersion" type="hidden" value="' + cc_Config.workflowVersion + '" />' +
									'<input id="' + question.id + '" style="display:none;" cc-disableable="' + question.id + '" cc-field="' + question.id + '" name="document" class="uploadDocumentFile btn btn-default peer" type="file" />' +
									'<label for="' + question.id + '" class="uploadDocumentButton">Choose</label>' +
								'</div>' +
							'</div>' +
						'</label>';
			}
		}else{
			html = '<div class="missingDocumentPanel" >' +
						'<div class="flex gap-2.5 items-center">' +
							'<i>' +
								'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
									'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
								'</svg>' +
							'</i>' +
							'<span class="font-bold">Add Document question is not supported in rulebook test mode.</span>' +
						'</div>' +
					'</div>';
		}

		return html;
	};
	
	cc_View.createDateQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		return	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + ' ' + disabledOutputClass + '" cc-type="' + question.type.value + '">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent">' + 
						'<div class="questionHeadingContainer">' +
							cc_View.createDateQuestionSegmentHtml(question, 'day') +
							cc_View.createDateQuestionSegmentHtml(question, 'month') +
							cc_View.createDateQuestionSegmentHtml(question, 'year') +
						'</div>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
	};
	
	cc_View.createQuestionResultAndErrorPanelHtml = function (question) {
		// this method can be called in two situations:
		//	1. as a next question being attached for the first time
		//	2. when a sub question is being added as a next question
		//
		// for case 2. the sub question's root parent is re-rendered. 
		//
		// an error should only be shown via this mechanism when it is being attached for the first
		// time, so it had not been viewed. this only occurs when the query interface method setError()
		// is run on a newly asked question
		var allowErrorToBeShown = question.viewed === false;
		
		return	'<div class="questionOutcomeContainer">' +
					'<div class="questionResultContainer">' + cc_View.createQuestionResult(question) + '</div>' +
					'<div class="questionErrorContainer">' + cc_View.createQuestionError(question, allowErrorToBeShown) + '</div>' +
				'</div>';
	};
	
	cc_View.createQuestionHelpPanelHtml = function (question) {
		var html = '';

		var helpText = cc_Model.getProperty(cc_Renderer.PROPERTY_HELP_TEXT, question);
		if(helpText != null){
			html += 	'<div class="questionHelpContainer" style="display:none;">' +
							helpText +
						'</div>';
		}
		
		return html;
	};
	
	cc_View.createQuestionHelpButtonHtml = function (question) {
		var html = '';

		if (question.type.value !== 'type-less') {
			var helpText = cc_Model.getProperty(cc_Renderer.PROPERTY_HELP_TEXT, question);
			if(helpText != null){
				html += 	'<div class="questionHelpButton self-center">' +
								'<span class="fa fa-question-circle fa-lg">' +
								'</span>' +
							'</div>';
			}
		}

		return html;
	};
	
	cc_View.createDateQuestionSegmentHtml = function (question, type) {
		var label, segmentHtml;
		
		if(type === 'year'){
			segmentHtml = cc_View.blankSelectedOption;
			for(var i = question.hints[3] ; i >= question.hints[2]; i--) {
				segmentHtml += '<option value="' + i + '">' + i +'</option>';
			};
			label = 'Year';
			
		}else if(type === 'month'){
			segmentHtml= cc_View.monthOptions;
			label = 'Month';
			
		}else{
			segmentHtml= cc_View.dayOptions;
			label = 'Day';
		}
		
		return '<div class="answerText datepickerItem">' +
					'<label class="font-bold">' + label + '</label>' +
					'<select class="form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '">' + segmentHtml + '</select>' +
				'</div>';
	};
	
	cc_View.getQuestionLayoutTextPosition = function (question, defaultLayoutTextPosition) {
		return 'fullWidthQuestion';
	};
	
	cc_View.createQuestionPlaceholder = function (question){
		var placeholder = cc_Model.getProperty(cc_Renderer.PROPERTY_PLACEHOLDER, question);
		return placeholder ? 'placeholder="' + placeholder + '"' : '';
	};
	
	cc_View.createQuestionText = function (question) {
		return question.text;
	};
	
	cc_View.findQuestionPanelById = function (id, filter) {
		return $('#' + cc_View.getQuestionPanelDivId(id) + (filter || ''));
	};
	
	cc_View.findQuestionFieldById = function (id, filter) {
		return $('div.questionContent [cc-field=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionPanelByField = function (jField) {
		return $(jField).closest('.questionPanel');
	}; 
	
	cc_View.findQuestionLabelByField = function (jField) {
		return $(jField).closest('label');
	}; 
	
	cc_View.findQuestionFieldDecoratorByField = function (jField) {
		return jField.parent().find('[cc-decorator-field]');
	}; 
	
	cc_View.findQuestionTextById = function (id, filter) { 
		return $('div.questionText[cc-text=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionDisabledById = function (id, filter) { 
		return $('[cc-disableable=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionSearchNoMatchPanelById = function (id, filter) { 
		return $('[cc-search-no-match-panel=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionHideablePanelById = function (id, filter) { 
		return $('[cc-hideable-panel=' + id + ']' + (filter || ''));
	};
	
	cc_View.createQuestionResult = function (question) {
		return 	'<div cc-result-panel="' + question.id + '" class="result_content">' + 
					(question.result ? cc_View.createResultMessage(question.result) : '') + 
				'</div>';
	};

	cc_View.createQuestionError = function (question, allowErrorToBeShown) {
		return 	'<div cc-error-panel="' + question.id + '" class="error_content">' + 
					(question.error && allowErrorToBeShown === true ? cc_View.createErrorMessage(question.error) : '') + 
				'</div>';
	};
	
	cc_View.getContainingDialogId = function(field) {
		var containingDialog = $(field).closest(".ui-dialog-content.ui-widget-content");
		return containingDialog.length > 0 ? containingDialog[0].id : null;
	};
	
	cc_View.isShowingDialogId = function(dialogId) {
		return $('#' + dialogId + ':visible').length > 0;
	};
	
}());